module.exports = __webpack_public_path__ + "static/media/icon_history.ea4109d5.svg";